import { InteractionRequiredAuthError } from '@azure/msal-browser';

// The API scopes are shared by every authenticated portal service.
export const apiScopes = [
  'https://cortechapb2c.onmicrosoft.com/corte-chap-api/orders.read',
  'https://cortechapb2c.onmicrosoft.com/corte-chap-api/invoices.read',
];

// React Query can request several resources simultaneously. Only one
// interactive recovery may be started per page load.
let redirectInProgress = null;

export function requiresInteraction(error) {
  const code = error?.errorCode || error?.code;
  return error instanceof InteractionRequiredAuthError ||
    ['interaction_required', 'login_required', 'consent_required'].includes(code) ||
    /AADB2C90077/i.test(String(error?.message || error?.errorMessage || ''));
}

export async function getAccessToken(instance, accounts = []) {
  const account = instance.getActiveAccount?.() || accounts?.[0];
  if (!account) {
    throw new Error('No hay una cuenta autenticada en Azure AD B2C.');
  }

  // Do not send another silent token request after interaction was requested.
  if (redirectInProgress) {
    await redirectInProgress;
    throw new Error('Se inició la recuperación de la sesión.');
  }

  const request = { scopes: apiScopes, account };
  try {
    const result = await instance.acquireTokenSilent(request);
    return result.accessToken;
  } catch (error) {
    if (!requiresInteraction(error)) {
      throw error;
    }

    // The account/instance come from the mounted MsalProvider. The redirect
    // must not be started more than once when several queries fail together.
    if (!redirectInProgress) {
      redirectInProgress = Promise.resolve()
        .then(() => instance.acquireTokenRedirect(request))
        .catch((redirectError) => {
          redirectInProgress = null;
          throw redirectError;
        });
    }
    await redirectInProgress;
    throw new Error('Se inició la recuperación de la sesión.');
  }
}
